import { render, staticRenderFns } from "./AddEditModal.vue?vue&type=template&id=1532a97e&scoped=true"
import script from "./AddEditModal.vue?vue&type=script&lang=js"
export * from "./AddEditModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditModal.vue?vue&type=style&index=0&id=1532a97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532a97e",
  null
  
)

export default component.exports